import React, { useEffect, useState } from 'react'
import { message, Spin } from 'antd'
import { CommonHistoryLogRequest } from '../../requests/CommonHistoryLogRequest'
import common_history_log from '../../enum_utils'
import date_format from '../../date_format'
import utils from '../../utils'

const MissionDetailHistory = props => {
  const { documentCode } = props
  const [list, setList] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (!documentCode) return
    ;(async () => {
      try {
        setIsLoading(true)
        const res = await CommonHistoryLogRequest.getList(documentCode)
        if (res.data && res.data.data) {
          setList(res.data.data)
        } else if (res.data && Array.isArray(res.data)) {
          setList(res.data)
        }
      } catch (err) {
        console.log(err)
        message.error('Không thể tải lịch sử')
      } finally {
        setIsLoading(false)
      }
    })()
  }, [documentCode])

  return (
    <div style={{ minHeight: 150, padding: 10 }}>
      <Spin spinning={isLoading}>
        {list && list.length > 0 ? (
          <ul style={{ listStyleType: 'disc', paddingLeft: 20 }}>
            {list.map((item, index) => {
              return (
                <li key={index} style={{ marginBottom: 16 }}>
                  <span style={{ marginBottom: 8, display: 'block' }}>
                    <b>{common_history_log.enumToText(item.action)}</b> lúc
                    <span>
                      {' '}
                      {date_format.HH_mm_DD_MM_YYYY(item.processed_date || item.created_at)}
                    </span>{' '}
                    bởi
                    <b>
                      {' '}
                      {item?.user
                        ? utils.getNameInCapitalize(
                            item.user.name_uppercase || item.user.username
                          )
                        : ''}
                    </b>
                  </span>
                </li>
              )
            })}
          </ul>
        ) : (
          !isLoading && (
            <div style={{ textAlign: 'center', color: '#999', paddingTop: 20 }}>
              Không có dữ liệu lịch sử
            </div>
          )
        )}
      </Spin>
    </div>
  )
}

export default MissionDetailHistory
